"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIPopover = _interopRequireDefault(require("UIComponents/tooltip/UIPopover"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _canvaLogo = _interopRequireDefault(require("bender-url!FileManagerImages/images/canva-logo.png"));

var _Canva = require("../constants/Canva");

var CanvaCreateButton = function CanvaCreateButton(_ref) {
  var disabledReason = _ref.disabledReason,
      dismissCanvaPopup = _ref.dismissCanvaPopup,
      hasNotSeenCanvaPopup = _ref.hasNotSeenCanvaPopup,
      isDisabled = _ref.isDisabled,
      isDownloading = _ref.isDownloading,
      loadingButton = _ref.loadingButton,
      openCanva = _ref.openCanva,
      specificCanvaTemplates = _ref.specificCanvaTemplates;
  var templates = specificCanvaTemplates || _Canva.CANVA_DEFAULT_TEMPLATES;
  return _react.default.createElement(_UIPopover.default, {
    onOpenChange: dismissCanvaPopup,
    open: hasNotSeenCanvaPopup,
    showCloseButton: true,
    use: "shepherd",
    width: 300,
    content: {
      header: _react.default.createElement("h4", null, _react.default.createElement(_FormattedMessage.default, {
        message: "FileManagerCore.canva.welcomePopup.header"
      })),
      body: _react.default.createElement("div", null, _react.default.createElement(_FormattedMessage.default, {
        message: "FileManagerCore.canva.welcomePopup.body"
      }), _react.default.createElement("br", null), _react.default.createElement(_UILink.default, {
        href: "https://knowledge.hubspot.com/cos-general/add-canva-designs-to-your-hubspot-content",
        external: true
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "FileManagerCore.canva.welcomePopup.learnMore"
      })))
    }
  }, _react.default.createElement(_UITooltip.default, {
    title: disabledReason
  }, isDownloading ? loadingButton : _react.default.createElement(_UISelect.default, {
    className: "m-x-2",
    disabled: isDisabled,
    menuWidth: 312,
    onClick: dismissCanvaPopup,
    onChange: function onChange(e) {
      return openCanva(e.target.value);
    },
    buttonUse: "tertiary-light",
    buttonSize: "small",
    placeholder: _react.default.createElement("div", null, _react.default.createElement(_UIImage.default, {
      alt: _I18n.default.text('FileManagerCore.actions.addFromCanva'),
      className: "m-x-1",
      height: 20,
      responsive: false,
      src: _canvaLogo.default,
      draggable: false
    }), _react.default.createElement(_FormattedMessage.default, {
      className: "canva-button-text m-x-1",
      message: "FileManagerCore.actions.addFromCanva"
    })),
    placement: "top left",
    value: "",
    options: templates.map(function (t) {
      return {
        text: _I18n.default.text("FileManagerCore.canva.typeLabels." + t),
        value: t
      };
    })
  })));
};

CanvaCreateButton.propTypes = {
  disabledReason: _propTypes.default.node,
  dismissCanvaPopup: _propTypes.default.func.isRequired,
  hasNotSeenCanvaPopup: _propTypes.default.bool.isRequired,
  isDisabled: _propTypes.default.bool.isRequired,
  isDownloading: _propTypes.default.bool.isRequired,
  loadingButton: _propTypes.default.node.isRequired,
  openCanva: _propTypes.default.func.isRequired,
  specificCanvaTemplates: _propTypes.default.arrayOf(_propTypes.default.oneOf(_Canva.CANVA_TEMPLATES))
};
var _default = CanvaCreateButton;
exports.default = _default;
module.exports = exports.default;